export default __webpack_public_path__ + "static/media/ORYX_ScissorsIcon.0e7f5d45.svg";